export default "__VITE_ASSET__CowKT9XG__"